import React from 'react';
import cn from 'classnames';
import { Theme } from '../../../enums';

export const RichText: React.FC<{ html: string; theme?: Theme }> = ({
    html,
    theme = Theme.Dark
}) => (
    <div className={cn('c-rich-text', theme)}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
);
